export default "__VITE_ASSET__33899460__"